import * as React from 'react';

interface Options {
	onChange: (fieldId: string, fieldValue: string | object) => void;
	additionalFields: Record<string, string | object>;
}

const withAdditionalFieldsComponent =
	(options: Options) =>
	<TProps extends object>(WrappedComponent: React.ComponentType<TProps>) => {
		const ReturnComponent: React.FC<TProps> = (props) => {
			return (
				<WrappedComponent
					{...props}
					onChange={options.onChange}
					additionalFields={options.additionalFields}
				/>
			);
		};

		ReturnComponent.displayName = 'WithAdditionalFieldsComponent';

		return ReturnComponent;
	};

export default withAdditionalFieldsComponent;
